import { useCallback } from "react";
import { useWeb3React } from "@web3-react/core";
import useWeb3 from "../useWeb3";
import { getLiquidityPool } from "../../utils/contractHelpers";
import { LUCKIFY_CONTRACT_ADDRESS } from "../../utils/Enviroment";

export const ResolveBet = () => {
  const web3 = useWeb3();
  const stakingAddress = LUCKIFY_CONTRACT_ADDRESS;
  const contract = getLiquidityPool(stakingAddress, web3);
  const { account } = useWeb3React();
  const ResolveBetHook = useCallback(async () => {
    let gasPrice = await web3?.eth?.getGasPrice();
    // gasPrice = parseInt(gasPrice) + 1000000000;
    try {
      let gas = await contract?.methods
        ?.resolveBet()
        ?.estimateGas({ from: account });
      gas = parseInt(gas) + 600000;
      console.log(gas, "gasgasgas");

      const resolveBet = await contract?.methods
        ?.resolveBet()
        ?.send({ from: account, gas: gas, gasPrice: gasPrice });
      return resolveBet;
    } catch (e) {
      throw e;
    }
  }, [contract, web3, account]);
  return { ResolveBetHook: ResolveBetHook };
};

export default ResolveBet;
